showMoreDirective.$inject = ["$parse"];

/*@ngInject*/
function showMoreDirective($parse) {
  return {
    scope: true,
    controller: 'ShowMoreCtrl',
    controllerAs: 'showMore',
    bindToController: true,
    link: function link(scope, element, attrs, ctrl) {
      ctrl.requestUrl = attrs.requestUrl || '';
      ctrl.urlParameter = attrs.urlParameter || 'page';
      ctrl.dataParams = $parse(attrs.dataParams)(scope) || {};
    }
  };
}

;

function showMoreInitHtmlDirective() {
  return {
    require: '^showMore',
    scope: true,
    controller: function showMoreInitHtmlController() {},
    link: function link(scope, element, attrs, showMoreCtrl) {
      showMoreCtrl.addInitHtmlContainer(element);
    }
  };
}

;
export { showMoreDirective, showMoreInitHtmlDirective };